// Module
var code = `<dx-button type="default" hint="Help" (onClick)="this.onHelpButtonClicked(\$event)"> <i class="fa-solid fa-question"></i> </dx-button> `;
// Exports
export default code;